import React, { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { NeuralChatOutletContext } from "../components/NeuralChatShell";
import { CenterState, StateCard } from "../styles";

export const NeuralChatHomePage: React.FC = () => {
  const { rooms } = useOutletContext<NeuralChatOutletContext>();
  const navigate = useNavigate();
  useEffect(() => { if (rooms[0]) navigate(`/neuralchat/rooms/${rooms[0].id}`, { replace: true }); }, [navigate, rooms]);
  return <CenterState><StateCard><h1>NeuralChat</h1><p>{rooms.length ? "채널을 여는 중입니다…" : "접근 가능한 채널이 없습니다. CEO가 기본 채널을 bootstrap한 뒤 다시 시도해 주세요."}</p></StateCard></CenterState>;
};
